import React from 'react';
import { NavLink } from 'react-router-dom';
import { useIntl } from '@edx/frontend-platform/i18n';
import SlTooltip from '@shoelace-style/shoelace/dist/react/tooltip';
import defaultBadgeImg from '../../img/achivements/default_badge.png';

import type { CertificateDisplayItem } from '../../types';
import messages from './messages';

interface CertificateDisplayProps {
  certificate: CertificateDisplayItem;
}

const CertificateDisplay: React.FC<CertificateDisplayProps> = ({ certificate }) => {
  const intl = useIntl();

  const credentialImageURL = certificate?.iconImage || defaultBadgeImg;

  const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.src = defaultBadgeImg;
  };

  const imageAndTitle = (
    <>
      {' '}
      <img
        data-name="badge_image"
        loading="lazy"
        alt=""
        src={credentialImageURL}
        onError={handleError}
        className="image-16"
      />
      <div>
        {certificate?.course_display_name}
      </div>
    </>
  );

  if (!certificate?.isEarned) {
    return (
      <SlTooltip>
        <div style={{ textAlign: 'center' }} slot="content">
          <span>
            {intl.formatMessage(messages.unearnedCertificateTooltip, {
              course: certificate?.course_display_name,
            })}
          </span>
        </div>
        <span className="cred-box disabled" aria-disabled="true">
          {imageAndTitle}
        </span>
      </SlTooltip>
    );
  }

  return (
    <NavLink
      className="cred-box"
      to={`/certificate/${certificate?.uuid}`}
      target="_blank"
    >
      {imageAndTitle}
    </NavLink>
  );
};

export default CertificateDisplay;
